export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('in');
    document.addEventListener('wpcf7mailsent', function() {   
      setTimeout(function() {
        $('.wpcf7-mail-sent-ok').delay(3000).fadeOut('slow').hide(0);
      }, 6000);       
    }, false);

      },
};



// WEBPACK FOOTER //
// ./scripts/routes/contactformsTcm.js